/**
 * Real curated property examples — same listings used by /examples, the
 * homepage hero (randomised on each visit), and any future page that wants
 * to show off real product output.
 *
 * All assets are CDN-hosted public URLs, no auth needed.
 */

export type RealExample = {
  property: string
  location: string
  price: string
  beds: number
  baths: number
  propertyImage: string
  thumbnails: string[]
  videoUrl: string
  videoPoster?: string
  agency: string
  sourceUrl: string
  shareUrl: string
}

export const REAL_EXAMPLES: RealExample[] = [
  {
    property: "Westbrook, Bromham",
    location: "Wiltshire, SN15",
    price: "\u00A31,195,000",
    beds: 7,
    baths: 5,
    propertyImage:
      "https://quiteright-public.up.railway.app/f5sy8x77bwxcav4l4h7dcoci1t8l",
    thumbnails: [
      "https://quiteright-public.up.railway.app/dtt714lf9ni7vz17avnqj0hpyw1j",
      "https://quiteright-public.up.railway.app/jciqczcwwtb8a24jfk9poqlu6x0n",
      "https://quiteright-public.up.railway.app/9pdnnh4kmj8v1fe1vqc1wukdtplw",
    ],
    videoUrl: "https://dudpw00jtfdjq.cloudfront.net/videos/39/8gml0euqb9uW/puAhVLs74w79.mp4",
    videoPoster: "https://quiteright-public.up.railway.app/un00sjqymoe1x1dfksyphzuel526",
    agency: "Strakers Estate Agency",
    sourceUrl:
      "https://www.strakers.co.uk/property-for-sale/7-bedroom-house-for-sale-in-westbrook-bromham-sn15-6985a68c458d9705409fc1c3/",
    shareUrl: "https://www.quiteright.co.uk/v/8gml0euqb9uW",
  },
  {
    property: "Ocean Key, Feock",
    location: "Truro, TR3",
    price: "\u00A31,695,000",
    beds: 4,
    baths: 4,
    propertyImage:
      "https://quiteright-public.up.railway.app/8lf16dqinmd2756zaz72t522pir3",
    thumbnails: [
      "https://quiteright-public.up.railway.app/49kumio6ktjc4entprhx3jfjau5a",
      "https://quiteright-public.up.railway.app/w04tz27ztrix9lem2yo9m31c7zd7",
      "https://quiteright-public.up.railway.app/nq3frnz6tku2a3nabxsc3mazncrt",
    ],
    videoUrl: "https://dudpw00jtfdjq.cloudfront.net/videos/28/ukwILmwacdX7/KNRBNsX289E7.mp4",
    agency: "Shore Partnership",
    sourceUrl: "https://shorepartnership.com/property/feock-truro-tr3-6rg/",
    shareUrl: "https://www.quiteright.co.uk/v/ukwILmwacdX7",
  },
  {
    property: "Leighton Road",
    location: "Cheltenham, GL52",
    price: "\u00A3525,000",
    beds: 4,
    baths: 2,
    propertyImage:
      "https://quiteright-public.up.railway.app/kgh9emfqbz51kxm6mbueqhn9chr9",
    thumbnails: [
      "https://quiteright-public.up.railway.app/8zwcth9c52qge3twkcnkzg1x3vre",
      "https://quiteright-public.up.railway.app/sfzlz1m9cjs1xi5mjieq572o1zbp",
      "https://quiteright-public.up.railway.app/xpwrp6jw4hgipdc1abob7gt7o2ln",
    ],
    videoUrl: "https://dudpw00jtfdjq.cloudfront.net/videos/16/SpXGy1x0R0p6/zhegqQwTywkh.mp4",
    agency: "Sam Ray Property",
    sourceUrl: "https://www.samrayproperty.co.uk/properties-for-sale/property/12275817-leighton-road-cheltenham",
    shareUrl: "https://www.quiteright.co.uk/v/SpXGy1x0R0p6",
  },
]
